import React from 'react'
import PropTypes from 'prop-types'

import { color } from '../../style/theme'
import { get } from 'lodash'

import DiceBadge from '../../assets/dice-icon.inline.svg'
import FoodBadge from '../../assets/food-icon.inline.svg'
import CardsBadge from '../../assets/cards-icon.inline.svg'
import TicketBadge from '../../assets/ticket-icon.inline.svg'
import MusicBadge from '../../assets/music-icon.inline.svg'
import PromoBadge from '../../assets/promo-icon.inline.svg'

import { BADGE_TYPES } from '../../../lib/constants'
const getFill = fill => get(color, fill) || fill

const defaultProps = {
  fill: color.blue,
}

const propTypes = {
  fill: PropTypes.string,
}

const BADGES = BADGE_TYPES.reduce((acc, value) => {
  switch (value) {
    case BADGE_TYPES[0]:
      acc[value] = FoodBadge
      break
    case BADGE_TYPES[1]:
      acc[value] = DiceBadge
      break
    case BADGE_TYPES[2]:
      acc[value] = CardsBadge
      break
    case BADGE_TYPES[3]:
      acc[value] = PromoBadge
      break
    case BADGE_TYPES[4]:
      acc[value] = MusicBadge
      break
    case BADGE_TYPES[5]:
      acc[value] = TicketBadge
      break
  }
  return acc
}, {})

export const Badge = ({ type }) => {
  const IconSvg = BADGES[type]

  return <IconSvg />
}

Badge.propTypes = {
  type: PropTypes.string,
}

export const Calendar = ({ fill, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke={fill}
    strokeWidth={2}
    strokeLinecap="square"
    strokeLinejoin="arcs"
    {...props}
  >
    <rect x={3} y={4} width={18} height={18} rx={2} ry={2} />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </svg>
)
Calendar.defaultProps = {
  fill: color.blue,
}
Calendar.propTypes = propTypes

export const CalendarWithDays = props => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
    <path
      fill="#1D355B"
      d="M14.125 0a.75.75 0 01.75.75v1.313l.01.059a.188.188 0 00.178.128h2.062a1.5 1.5 0 011.5 1.5V16.5a1.5 1.5 0 01-1.5 1.5H2.875a1.5 1.5 0 01-1.5-1.5V3.75l.007-.144A1.5 1.5 0 012.875 2.25H4l.076.008c.17.035.299.186.299.367v1.688a.562.562 0 101.125 0V.75a.75.75 0 111.5 0v1.313c0 .104.084.187.187.187h4.688c.207 0 .375.168.375.375v1.688a.562.562 0 101.125 0V.75a.75.75 0 01.75-.75zm2.625 6.75H3.25a.375.375 0 00-.375.375v9l.008.076c.035.17.186.299.367.299h13.5a.375.375 0 00.375-.375v-9a.375.375 0 00-.375-.375zM6.625 13.875a.75.75 0 110 1.5h-.75a.75.75 0 110-1.5zm3.75 0a.75.75 0 110 1.5h-.75a.75.75 0 110-1.5zm3.75 0a.75.75 0 110 1.5h-.75a.75.75 0 110-1.5zm-7.5-3a.75.75 0 110 1.5h-.75a.75.75 0 110-1.5zm3.75 0a.75.75 0 110 1.5h-.75a.75.75 0 110-1.5zm3.75 0a.75.75 0 110 1.5h-.75a.75.75 0 110-1.5zm-7.5-3a.75.75 0 110 1.5h-.75a.75.75 0 110-1.5zm3.75 0a.75.75 0 110 1.5h-.75a.75.75 0 110-1.5zm3.75 0a.75.75 0 110 1.5h-.75a.75.75 0 110-1.5z"
    />
  </svg>
)

export const AddToCalendar = props => (
  <svg width="18px" height="18px" viewBox="0 0 18 18" {...props}>
    <path
      d="M13.125 8.25a4.875 4.875 0 110 9.75 4.875 4.875 0 010-9.75zm0 2.438a.562.562 0 00-.563.562v1.125a.188.188 0 01-.187.188H11.25a.562.562 0 100 1.125h1.125c.104 0 .188.083.188.187V15a.562.562 0 101.124 0v-1.125c0-.104.084-.187.188-.187H15a.562.562 0 100-1.125h-1.125a.188.188 0 01-.188-.188V11.25l-.007-.091a.563.563 0 00-.555-.471zM10.5 0c.31 0 .562.252.562.563v.75l.01.059a.188.188 0 00.178.128h1.875a.75.75 0 01.75.75v4.928a5.46 5.46 0 00-1.5 0V5.625A.375.375 0 0012 5.25H1.875a.375.375 0 00-.375.375V12l.008.076c.035.17.186.299.367.299h5.302a5.46 5.46 0 000 1.5H1.5a1.5 1.5 0 01-1.5-1.5V2.25l.007-.102A.75.75 0 01.75 1.5h1.687c.208 0 .375.168.375.375v1.5a.562.562 0 101.125 0V.563a.562.562 0 111.125 0v.75l.01.059a.188.188 0 00.178.128h3.187c.208 0 .375.168.375.375v1.5a.562.562 0 101.125 0V.563c0-.311.252-.563.563-.563z"
      fillRule="nonzero"
      fill="#316094"
    />
  </svg>
)

export const Close = props => (
  <svg width="1em" height="1em" viewBox="0 0 18 18" {...props}>
    <path d="M.82 16.32L15.97.41l1.21 1.27L2.03 17.59.82 16.32z" />
    <path d="M2.03.41l15.15 15.91-1.21 1.27L.82 1.68 2.03.41z" />
  </svg>
)

export const Download = props => (
  <svg width="1em" height="1em" viewBox="0 0 18 17" {...props}>
    <path
      d="M9.001 5.544c.622 0 1.125.503 1.125 1.125v5.436l.01.06a.188.188 0 00.178.128h1.312a.75.75 0 01.53 1.283L9.532 16.2a.75.75 0 01-1.06 0l-2.625-2.624a.75.75 0 01.53-1.28h1.312a.187.187 0 00.188-.188v-5.44c0-.62.503-1.124 1.124-1.124zM6.041.817a5.762 5.762 0 017.902 1.989l.038.045c.029.025.066.041.105.045l.242.03c.88.132 1.7.536 2.343 1.159l.164.167A4.362 4.362 0 0118 7.206l-.005.214a4.355 4.355 0 01-3.876 4.116l-.049.005-.049.002-.102-.006a.75.75 0 01.003-1.488l.173-.023a2.876 2.876 0 002.405-2.82l-.006-.192a2.814 2.814 0 00-.864-1.852l-.141-.13a2.765 2.765 0 00-1.927-.656h-.1a.72.72 0 01-.605-.428l-.1-.198a4.264 4.264 0 00-8.014 1.764l-.005.053-.01.053a.75.75 0 01-.885.583l-.173-.028a1.95 1.95 0 00-1.452.423l-.13.116a1.932 1.932 0 00-.585 1.39l-.004.163c.01.436.181.856.483 1.176l.155.124c.426.311.942.479 1.473.476l.101.007c.364.05.647.356.66.732l-.005.102a.75.75 0 01-.733.659l-.248-.01A4.146 4.146 0 01.93 10.51l-.14-.151a3.243 3.243 0 01-.787-2.256l.005-.185A3.442 3.442 0 013.2 4.676l.048-.01a.188.188 0 00.122-.14l.066-.271A5.762 5.762 0 016.041.817z"
      fill="#316094"
      fillRule="nonzero"
    />
  </svg>
)

export const Facebook = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path
      fill="#3B5998"
      d="M21.964.8H2.036C1.353.8.8 1.353.8 2.036v19.928c0 .682.553 1.236 1.236 1.236h10.729v-8.674h-2.92v-3.381h2.92V8.652c0-2.893 1.767-4.469 4.348-4.469 1.236 0 2.298.092 2.608.133V7.34h-1.79c-1.404 0-1.675.668-1.675 1.647v2.158h3.347l-.436 3.38h-2.911V23.2h5.708c.682 0 1.236-.554 1.236-1.236V2.036C23.2 1.353 22.646.8 21.964.8"
    />
  </svg>
)

export const FormDownArrow = ({ fill, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 12 7" {...props}>
    <path
      d="M10.406.217l1.245 1.566L6 6.278.35 1.783 1.593.217 6 3.722z"
      fill={getFill(fill)}
      fillRule="nonzero"
    />
  </svg>
)

FormDownArrow.defaultProps = defaultProps
FormDownArrow.propTypes = propTypes

// Fork and knife
export const Food = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 27" {...props}>
    <path
      d="M14.859 1v25m0-25c-1.501 0-3.261 7.058-3.261 15.76h3.26M1 1v5.435a3.26 3.26 0 106.522 0V1M4.26 1v25"
      stroke="#008FBE"
      strokeWidth={1.62}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const DownArrow = ({ fill, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 10 6" {...props}>
    <path fill={getFill(fill)} fillRule="nonzero" d="M0 0l4.99 6L10 0z" />
  </svg>
)

DownArrow.defaultProps = defaultProps
DownArrow.propTypes = propTypes

export const Hamburger = ({ fill, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 25 16" {...props}>
    <path
      fillRule="nonzero"
      fill={getFill(fill)}
      d="M0 7h25v2H0zM0 14h25v2H0zM0 0h25v2H0z"
    />
  </svg>
)

Hamburger.defaultProps = defaultProps
Hamburger.propTypes = propTypes

// Clock icon
export const Hours = props => (
  <svg width="1em" height="1em" viewBox="0 0 18 18" {...props}>
    <path
      fill="#008FBE"
      d="M9 .5A8.51 8.51 0 0117.5 9 8.5 8.5 0 118.745.504L9 .5zm0 1.588a6.912 6.912 0 000 13.824A6.92 6.92 0 0015.912 9 6.912 6.912 0 009 2.088zm-.35 2.265c.438 0 .794.355.794.794l-.03 3.477L12.66 11.6a.794.794 0 01.048 1.122.801.801 0 01-1.12.048L8.112 9.586A.794.794 0 017.856 9V5.147c0-.439.355-.794.794-.794z"
    />
  </svg>
)

export const Info = props => (
  <svg width="1em" height="1em" viewBox="0 0 18 18" {...props}>
    <path
      fill="#008FBE"
      d="M9 .5A8.51 8.51 0 0117.5 9 8.5 8.5 0 119 .5zM8.998 2A7 7 0 009 16a7 7 0 007-6.998A7.01 7.01 0 008.998 2zm-.352 5.23c.782 0 1.416.633 1.416 1.416v3.364c0 .098.08.178.178.178h.53a.708.708 0 110 1.416H7.938a.708.708 0 110-1.416h.532c.098 0 .177-.08.177-.178V8.823a.177.177 0 00-.177-.177h-.532a.708.708 0 110-1.417h.709zm.531-3.188A1.063 1.063 0 118.121 5.22l-.006-.116c0-.548.414-.998.946-1.056l.116-.006z"
    />
  </svg>
)

export const Instagram = ({ fill, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path
      fill={getFill(fill)}
      d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"
    />
  </svg>
)

Instagram.defaultProps = defaultProps
Instagram.propTypes = propTypes

export const InstagramInColor = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <defs>
      <radialGradient
        id="prefix__a"
        cx="-16.693%"
        cy="161.773%"
        r="413.614%"
        fx="-16.693%"
        fy="161.773%"
        gradientTransform="scale(.99903 1) rotate(-9.531 -.167 1.619)"
      >
        <stop stopColor="#FED576" offset="0%" />
        <stop stopColor="#F47133" offset="26.335%" />
        <stop stopColor="#BC3081" offset="60.907%" />
        <stop stopColor="#4C63D2" offset="100%" />
      </radialGradient>
      <radialGradient
        id="prefix__b"
        cx="-448.56%"
        cy="733.516%"
        r="1735.264%"
        fx="-448.56%"
        fy="733.516%"
        gradientTransform="matrix(.9862 -.1645 .16558 .97972 -1.276 -.59)"
      >
        <stop stopColor="#FED576" offset="0%" />
        <stop stopColor="#F47133" offset="26.335%" />
        <stop stopColor="#BC3081" offset="60.907%" />
        <stop stopColor="#4C63D2" offset="100%" />
      </radialGradient>
      <radialGradient
        id="prefix__c"
        cx="15.933%"
        cy="107.287%"
        r="211.726%"
        fx="15.933%"
        fy="107.287%"
        gradientTransform="matrix(.98442 -.16558 .16528 .9862 -.175 .041)"
      >
        <stop stopColor="#FED576" offset="0%" />
        <stop stopColor="#F47133" offset="26.335%" />
        <stop stopColor="#BC3081" offset="60.907%" />
        <stop stopColor="#4C63D2" offset="100%" />
      </radialGradient>
    </defs>
    <g fill="none">
      <path
        fill="url(#prefix__a)"
        d="M11.207 5.472a5.74 5.74 0 00-1.698.258 5.685 5.685 0 00-1.94 1.052 5.795 5.795 0 00-1.637 2.19 5.673 5.673 0 000 4.444 5.706 5.706 0 001.23 1.819 5.795 5.795 0 001.821 1.229 5.685 5.685 0 003.923.193 5.685 5.685 0 001.94-1.052 5.796 5.796 0 001.637-2.19 5.673 5.673 0 000-4.444 5.706 5.706 0 00-1.23-1.819 5.796 5.796 0 00-1.821-1.229 5.685 5.685 0 00-2.225-.451zm0 1.975a3.859 3.859 0 011.12.167 3.729 3.729 0 012.63 3.58 3.848 3.848 0 01-.167 1.118 3.72 3.72 0 01-2.463 2.46 3.747 3.747 0 01-1.12.168 3.86 3.86 0 01-1.12-.167 3.729 3.729 0 01-2.63-3.58 3.846 3.846 0 01.168-1.118 3.72 3.72 0 012.463-2.46 3.748 3.748 0 011.12-.168z"
        transform="translate(.8 .8)"
      />
      <path
        fill="url(#prefix__b)"
        d="M17.167 3.844a1.35 1.35 0 00-.978.417 1.37 1.37 0 00-.38 1.093 1.381 1.381 0 00.621 1.018 1.362 1.362 0 001.507-.022 1.365 1.365 0 00.59-1.036 1.381 1.381 0 00-.742-1.32 1.36 1.36 0 00-.618-.15z"
        transform="translate(.8 .8)"
      />
      <path
        fill="url(#prefix__c)"
        d="M10.121 0c-.623 0-1.178.002-1.678.009-.5.007-.942.019-1.339.036-.396.017-.747.04-1.061.068a13.102 13.102 0 00-.847.108 7.646 7.646 0 00-.693.152A5.85 5.85 0 003.9.575a7.538 7.538 0 00-.991.486 4.504 4.504 0 00-.737.554c-.12.11-.243.23-.372.366-.16.169-.3.326-.425.48a5.094 5.094 0 00-.33.463 4.37 4.37 0 00-.266.493A6.904 6.904 0 00.27 4.984a9.052 9.052 0 00-.095.602c-.027.219-.05.458-.07.724-.021.266-.038.558-.051.884a50.8 50.8 0 00-.033 1.083c-.008.398-.013.836-.017 1.32a217.89 217.89 0 00.01 3.915c.01.676.025 1.258.046 1.757.01.25.022.478.035.686.013.21.028.398.044.57.016.17.034.323.053.458.02.136.04.254.063.357.047.213.1.42.16.62.062.199.13.392.204.578a6.283 6.283 0 00.534 1.034 5.5 5.5 0 001.59 1.603c.15.099.297.19.445.274a5.564 5.564 0 001.445.564c.18.044.372.083.576.117.203.033.42.062.652.087.231.025.479.046.745.063.265.017.55.03.855.042.471.017 1.185.027 2.009.03a214.164 214.164 0 005.188-.04 67.6 67.6 0 00.96-.027 10.61 10.61 0 001.39-.123 7.953 7.953 0 00.702-.147 6.939 6.939 0 001.312-.484c.166-.08.3-.147.416-.212a2.89 2.89 0 00.318-.202c.1-.074.2-.158.315-.264.115-.106.245-.233.406-.394.141-.142.26-.265.364-.376.103-.112.19-.213.266-.31a3.293 3.293 0 00.376-.596c.085-.168.162-.323.23-.473.068-.15.129-.295.182-.441.053-.147.1-.295.14-.452.04-.157.075-.323.105-.505s.056-.38.078-.601c.022-.221.04-.466.057-.74.017-.275.03-.58.044-.922a121.097 121.097 0 00.064-2.423 114.963 114.963 0 00-.045-5.132 51.819 51.819 0 00-.044-1.009 22.595 22.595 0 00-.055-.786 5.438 5.438 0 00-.063-.508 8.577 8.577 0 00-.184-.754 7.314 7.314 0 00-.244-.695 6.38 6.38 0 00-.306-.636 5.748 5.748 0 00-.572-.844 5.303 5.303 0 00-1.257-1.11 5.835 5.835 0 00-.609-.34c-.175-.086-.337-.162-.496-.229a5.061 5.061 0 00-.997-.31 7.41 7.41 0 00-.62-.096 14.43 14.43 0 00-.781-.067A33.104 33.104 0 0015.108.06c-.377-.011-.802-.02-1.283-.028A283.016 283.016 0 0010.121 0zm1.08 1.973c1.065 0 2.13.006 3 .017.434.006.82.013 1.131.022.312.009.55.02.689.031.181.015.354.034.52.057.165.023.322.05.473.082.15.032.294.067.432.108.138.04.269.086.395.136a3.929 3.929 0 01.698.363 3.77 3.77 0 01.605.498c.101.1.194.203.28.308a3.365 3.365 0 01.593 1.09c.048.142.09.292.129.454.037.16.07.332.1.516.028.183.052.38.073.589.021.21.038.433.052.673.012.191.022.445.03.744.009.299.016.644.021 1.02a169.482 169.482 0 01-.024 6.01 20.75 20.75 0 01-.1 1.631 8.988 8.988 0 01-.043.355 5.91 5.91 0 01-.118.59 4.09 4.09 0 01-.177.52 6.385 6.385 0 01-.116.267 3.968 3.968 0 01-.243.446 3.51 3.51 0 01-.458.575 3.353 3.353 0 01-.576.466 3.815 3.815 0 01-.452.252 4.516 4.516 0 01-.51.205c-.179.061-.368.115-.567.161a7.62 7.62 0 01-.628.118 6.84 6.84 0 01-.534.033c-.267.01-.615.02-1.018.029a254.123 254.123 0 01-5.902.042 96.53 96.53 0 01-1.184-.013 21.25 21.25 0 01-.77-.024 22.479 22.479 0 01-.567-.04c-.177-.015-.34-.031-.494-.05a8.439 8.439 0 01-.43-.063 5.775 5.775 0 01-.38-.079 4.38 4.38 0 01-.653-.216 3.842 3.842 0 01-.583-.313 4.357 4.357 0 01-.408-.294 3.543 3.543 0 01-.505-.513 3.251 3.251 0 01-.387-.62 3.972 3.972 0 01-.199-.486 5.579 5.579 0 01-.155-.552 7.872 7.872 0 01-.116-.626 11.572 11.572 0 01-.08-.707c-.015-.184-.027-.47-.036-.832-.01-.363-.016-.8-.02-1.287a193.637 193.637 0 01.063-6.41c.013-.438.028-.815.043-1.104.008-.145.016-.268.025-.365.008-.098.017-.17.026-.213.03-.143.06-.275.09-.4.03-.124.063-.24.096-.348.033-.11.069-.211.106-.308a3.375 3.375 0 01.263-.528c.05-.082.105-.161.165-.24.06-.078.124-.156.194-.235a5.677 5.677 0 01.525-.516 3.308 3.308 0 01.97-.587c.122-.048.249-.09.383-.128a5.36 5.36 0 01.429-.102c.151-.03.312-.055.484-.078s.354-.042.55-.059c.136-.012.371-.022.68-.031.31-.009.693-.016 1.126-.022.866-.012 1.93-.018 2.994-.019z"
        transform="translate(.8 .8)"
      />
    </g>
  </svg>
)

// Map Pin
export const Location = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 19" {...props}>
    <path
      fill="#008FBE"
      d="M8 0a7.98 7.98 0 017.98 7.98c0 1.183-.5 2.507-1.403 3.972-.62 1.008-1.421 2.063-2.36 3.145a41.985 41.985 0 01-3.632 3.683.887.887 0 01-1.17 0 40.741 40.741 0 01-1.14-1.062 41.985 41.985 0 01-2.491-2.621c-.94-1.082-1.74-2.137-2.36-3.145C.52 10.487.02 9.162.02 7.98A7.98 7.98 0 018 0zm0 1.773A6.207 6.207 0 001.794 7.98c0 .79.393 1.831 1.14 3.042.564.916 1.309 1.898 2.19 2.913A40.24 40.24 0 008 16.912a40.24 40.24 0 002.877-2.978c.88-1.014 1.626-1.996 2.19-2.912.746-1.21 1.14-2.252 1.14-3.042A6.207 6.207 0 008 1.773zm1.324 4.39a1.872 1.872 0 11-2.647 2.648 1.872 1.872 0 012.647-2.647z"
    />
  </svg>
)

export const LogoMark = props => (
  <svg width={210} height={50} {...props}>
    <path
      d="M88.116 38.095c-4.592-1.346-8.642-2.751-10.844-4.466-.71-.586-1.403-1.307-1.435-2.415-.013-.863.555-1.626 1.21-2.08.668-.479 1.473-.81 2.492-1.113 3.863-1.13 7.99-1.743 11.573-2.547 3.591-.787 6.56-1.803 8.167-3.356 1.071-1.033 1.711-2.274 1.755-4.252v-.064c-.002-1.348-.853-2.632-2.939-3.996-2.063-1.337-5.244-2.574-9.182-3.624-7.883-2.11-18.775-3.525-30.23-4.442C35.794 3.9 10.636 3.98 1.656 3.895h-.05a1.74 1.74 0 01-.545-.09H1.06a.188.188 0 00-.03-.01c-.003-.002-.004-.002-.006-.005-.01-.001-.02-.005-.029-.007C.992 3.782.99 3.78.99 3.777.982 3.775.971 3.775.963 3.77a.033.033 0 00-.014-.005C.943 3.762.936 3.757.93 3.756a.063.063 0 00-.017-.007.043.043 0 00-.016-.006l-.023-.011C.872 3.73.869 3.73.868 3.727l-.03-.014-.004-.002C.378 3.485.05 3.065.005 2.566c-.07-.796.594-1.488 1.491-1.551C10.916.348 22.073 0 33.894 0c30.673.006 65.736 2.332 86.524 7.74 6.946 1.822 12.323 3.936 15.586 6.699 1.854 1.57 3.043 3.487 3.038 5.62 0 .074 0 .157-.007.251-.103 2.786-1.88 4.958-4.198 6.407-2.323 1.475-5.227 2.4-8.167 3.038-3.053.658-6.162.994-8.672 1.168 23.56 11.996 58.172 14.364 77.786 14.34 5.549 0 9.915-.184 12.455-.373.885-.067 1.665.513 1.753 1.296.087.787-.559 1.486-1.439 1.574-13.543 1.324-26.013 1.88-37.42 1.88-41.466.005-68.94-7.338-83.017-11.545"
      fill="#FDB61B"
      fillRule="nonzero"
    />
  </svg>
)

export const LinkOut = ({ fill, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 18 18" {...props}>
    <path
      d="M16.714 2.194l-7.26 7.26a.642.642 0 01-.908-.91l7.26-7.258h-4.877a.643.643 0 110-1.286h6.428A.643.643 0 0118 .643V7.07a.643.643 0 11-1.286 0V2.194zm-14.787.377C.863 2.571 0 3.431 0 4.495v11.581C0 17.137.873 18 1.931 18h11.565a1.929 1.929 0 001.931-1.932v-3.211a.642.642 0 00-1.286 0v3.212a.64.64 0 01-.645.645H1.931a.648.648 0 01-.645-.638V4.495a.64.64 0 01.641-.638h3.216a.643.643 0 100-1.286H1.927z"
      fill={getFill(fill)}
      fillRule="evenodd"
    />
  </svg>
)

LinkOut.defaultProps = {
  fill: color.secondaryLightBlue,
}
LinkOut.propTypes = propTypes

export const MoreDots = props => (
  <svg viewBox="0 0 25 5" width="1em" height="1em" {...props}>
    <path
      d="M2.5 0A2.5 2.5 0 110 2.5 2.5 2.5 0 012.5 0zm10 0A2.5 2.5 0 1110 2.5 2.5 2.5 0 0112.5 0zm10 0A2.5 2.5 0 1120 2.5 2.5 2.5 0 0122.5 0z"
      fill="#fdb61b"
    />
  </svg>
)

export const Picture = props => (
  <svg width={15} height={13} {...props}>
    <path
      d="M13.6.515c.478 0 .859.39.859.869v10.045c0 .479-.38.868-.86.868H1.573a.862.862 0 01-.859-.868V1.384c0-.479.38-.869.86-.869zm-.528.982H2.097a.404.404 0 00-.402.36v7.992l3.881-4.682a.677.677 0 011.028-.01l1.65 1.786c.047.046.102.098.133.126a.508.508 0 00.337.126c.138 0 .233-.059.353-.144l.574-.485c.126-.101.236-.175.393-.175.16 0 .3.083.392.19l3.04 3.274-.008-7.99a.39.39 0 00-.396-.368zm-2.05.982a1.473 1.473 0 110 2.946 1.473 1.473 0 010-2.946z"
      fillRule="nonzero"
      fill="#FDB61B"
    />
  </svg>
)

export const Plus = ({ fill, ...props }) => (
  <svg width={10} height={10} {...props}>
    <path
      d="M5 .2a.6.6 0 01.6.6l-.001 3.6H9.2a.6.6 0 010 1.2l-3.601-.001L5.6 9.2a.6.6 0 01-1.2 0V5.599L.8 5.6a.6.6 0 110-1.2h3.6V.8A.6.6 0 015 .2z"
      fill={fill}
      fillRule="nonzero"
    />
  </svg>
)

Plus.propTypes = {
  fill: PropTypes.string,
}

Plus.defaultProps = {
  fill: '#008FBE',
}

export const PlusMinus = ({ open, ...props }) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    {!open ? (
      <path
        d="M8 0a1 1 0 011 1v6h6a1 1 0 010 2H9v6a1 1 0 01-2 0V9H1a1 1 0 110-2h6V1a1 1 0 011-1z"
        fill="#FDB61B"
      />
    ) : (
      <path d="M1 9a1 1 0 110-2h14a1 1 0 010 2H1z" fill="#1D355B" />
    )}
  </svg>
)

PlusMinus.propTypes = {
  open: PropTypes.bool,
}

export const PrevNextArrow = ({ fill, left, ...props }) => {
  const path = left
    ? 'M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm1.283 6.6l.917.917-3.667 3.666 3.667 3.668-.917.917L8.7 12.183 13.283 7.6z'
    : 'M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm-1.283 6.6l-.917.917 3.667 3.666L9.8 15.851l.917.917 4.583-4.585L10.717 7.6z'

  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path d={path} fill={fill} fillRule="nonzero" />
      )}
    </svg>
  )
}

PrevNextArrow.defaultProps = {
  fill: color.secondaryLightBlue,
}
PrevNextArrow.propTypes = {
  ...propTypes,
  left: PropTypes.bool,
}

export const PrevNextSimpleArrow = ({ fill, left, ...props }) => {
  const path = left ? 'M9,17L1,9l8-8' : 'M1,1l8,8l-8,8'

  return (
    <svg width="1em" height="1em" viewBox="0 0 10 18" {...props}>
      <path
        d={path}
        stroke={fill}
        strokeWidth={2}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

PrevNextSimpleArrow.defaultProps = {
  fill: '#ffffff',
}
PrevNextSimpleArrow.propTypes = {
  ...propTypes,
  left: PropTypes.bool,
}

export const Rules = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 19" {...props}>
    <path
      d="M4.271 3.04l.05.007a.19.19 0 01.133.132l.007.051v1.14a.19.19 0 01-.14.183l-.05.007h-1.71a.38.38 0 00-.372.303l-.008.077V17.1l.008.076a.38.38 0 00.296.296l.076.007h8.203a.38.38 0 00.21-.063l.058-.048 2.438-2.437a.38.38 0 00.104-.195l.007-.074V4.94a.38.38 0 00-.303-.372L13.2 4.56h-1.71a.19.19 0 01-.183-.14l-.007-.05V3.23l.007-.05a.19.19 0 01.133-.133l.05-.007h2.09a1.52 1.52 0 011.514 1.382l.006.138v12.92a1.52 1.52 0 01-1.381 1.514L13.58 19h-11.4a1.52 1.52 0 01-1.514-1.382l-.006-.138V4.56l.006-.138a1.52 1.52 0 011.376-1.376l.138-.006h2.09zm3.04 9.88a.57.57 0 110 1.14h-2.85a.57.57 0 110-1.14zm3.99-2.66a.57.57 0 01.563.477l.007.092-.007.093a.57.57 0 01-.47.47l-.093.007h-6.84a.57.57 0 01-.092-1.132l.092-.008h6.84zm0-2.66a.57.57 0 01.093 1.133l-.093.007h-6.84a.57.57 0 01-.092-1.133L4.46 7.6h6.84zM7.871.759a2.285 2.285 0 012.285 2.125l.005.156v1.9a.76.76 0 01-.657.753l-.103.007h-3.04a.76.76 0 01-.753-.657l-.007-.103V3.106A2.314 2.314 0 017.103.896L7.267.84l.2-.045C7.6.77 7.735.759 7.871.759zm.01 1.521a.57.57 0 00-.562.478l-.008.092.008.092c.039.241.23.431.47.47l.092.008.093-.007A.57.57 0 007.88 2.28z"
      fillRule="nonzero"
      fill="#316094"
    />
  </svg>
)

export const SmallArrow = ({ fill, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
    <path
      d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zM8.834 6L8 6.834l3.333 3.333L8 13.5l.834.834L13 10.167 8.834 6z"
      fill={getFill(fill)}
      fillRule="nonzero"
    />
  </svg>
)

SmallArrow.defaultProps = defaultProps
SmallArrow.propTypes = propTypes

export const SmallLinkArrow = ({ fill, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 7 12" {...props}>
    <path
      d="M.217 1.594L1.783.35 6.278 6l-4.495 5.65-1.566-1.244L3.722 6z"
      fill={fill}
      fillRule="nonzero"
    />
  </svg>
)

SmallLinkArrow.propTypes = {
  fill: PropTypes.string,
}

SmallLinkArrow.defaultProps = {
  fill: '#FDB61B',
}

export const Search = ({ fill, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 14 14" {...props}>
    <path
      d="M13.749 12.533l-3.472-3.47a5.66 5.66 0 001.108-3.37A5.7 5.7 0 005.692 0 5.699 5.699 0 000 5.693a5.7 5.7 0 005.693 5.693 5.66 5.66 0 003.37-1.108l3.47 3.47a.86.86 0 001.215-1.215zM5.693 9.667a3.978 3.978 0 01-3.974-3.974 3.978 3.978 0 013.974-3.974 3.979 3.979 0 013.974 3.974 3.979 3.979 0 01-3.974 3.974z"
      fill={getFill(fill)}
      fillRule="evenodd"
    />
  </svg>
)

Search.defaultProps = {
  ...defaultProps,
  fill: color.blue,
}
Search.propTypes = propTypes

export const Share = props => (
  <svg width="1em" height="1em" viewBox="0 0 14 12" {...props}>
    <path
      d="M14 5.93L8.167.39V3.5C2.722 4.278.777 8.167 0 12.056c1.944-2.723 4.278-3.967 8.167-3.967v3.189L14 5.93z"
      fillRule="nonzero"
      fill="#316094"
    />
  </svg>
)

//@NOTE Yellow star used in the form
export const Star = props => (
  <svg width="1em" height="1em" viewBox="0 0 10 9" {...props}>
    <path
      fillRule="nonzero"
      d="M9.295 3.901H6.01L5 .851 3.991 3.9H.705L3.393 5.78l-1.047 3.05L5 6.94l2.654 1.89-1.049-3.05z"
      fill="#FDB61B"
    />
  </svg>
)

export const Twitter = props => (
  <svg width="1em" height="1em" viewBox="0 0 20 17" {...props}>
    <path
      d="M19.6 2.472a7.795 7.795 0 01-2.262.628A3.995 3.995 0 0019.07.892a7.826 7.826 0 01-2.502.969A3.91 3.91 0 0013.693.6c-2.176 0-3.94 1.787-3.94 3.992 0 .312.036.617.103.91-3.274-.167-6.177-1.756-8.12-4.171a4.014 4.014 0 00-.533 2.006c0 1.385.696 2.607 1.753 3.323a3.884 3.884 0 01-1.785-.5v.05c0 1.935 1.358 3.548 3.16 3.915a3.896 3.896 0 01-1.779.068c.501 1.586 1.956 2.74 3.68 2.772A7.838 7.838 0 01.4 14.618a11.043 11.043 0 006.038 1.794c7.246 0 11.208-6.083 11.208-11.358 0-.173-.004-.345-.012-.516A8.066 8.066 0 0019.6 2.472"
      fill="#1DA1F2"
      fillRule="nonzero"
    />
  </svg>
)

export const Upload = props => (
  <svg width="1em" height="1em" viewBox="0 0 22 21" {...props}>
    <path
      d="M11.638 7.516l3.15 3.15a.9.9 0 01-.637 1.536v.003h-1.575c-.103 0-.19.07-.216.165l-.009.06v6.524a1.35 1.35 0 01-2.7 0v-6.527c0-.125-.1-.225-.224-.225H7.852a.9.9 0 01-.636-1.536l3.15-3.15a.9.9 0 011.272 0zm-4.19-5.935a6.915 6.915 0 019.484 2.386l.032.042a.224.224 0 00.14.066l.267.032a5.14 5.14 0 012.834 1.395l.186.188A5.235 5.235 0 0121.8 9.248l-.005.227a5.226 5.226 0 01-4.652 4.968l-.059.006-.059.003-.112-.007a.9.9 0 01-.006-1.786l.185-.024A3.451 3.451 0 0020 9.248l-.006-.213a3.376 3.376 0 00-1.038-2.24L18.8 6.65a3.318 3.318 0 00-2.325-.8h-.12a.863.863 0 01-.727-.513l-.104-.209A5.117 5.117 0 005.89 7.217l-.006.064-.01.063a.9.9 0 01-1.063.7l-.189-.032a2.34 2.34 0 00-1.761.506l-.132.115a2.318 2.318 0 00-.727 1.69l-.005.178c.008.53.214 1.041.58 1.43l.167.135a2.97 2.97 0 001.788.586l.112.007a.92.92 0 01.8.88l-.004.112a.9.9 0 01-.881.8l-.256-.008a4.975 4.975 0 01-2.988-1.23l-.157-.17a3.891 3.891 0 01-.956-2.72l.006-.207a4.13 4.13 0 013.83-3.905l.058-.012a.226.226 0 00.147-.167l.067-.278a6.915 6.915 0 013.138-4.173z"
      fill="#316094"
      fillRule="nonzero"
    />
  </svg>
)

export const Recurring = props => (
  <svg viewBox="0 0 16 13" {...props}>
    <path
      d="M1.88891 4.7501C2.58474 2.02438 5.06263 0 8.00009 0L8.00048 0C9.76299 0 11.3617 0.727866 12.5061 1.90011L11.545 3.22791C10.6879 2.2383 9.41991 1.61122 8.00044 1.61122C5.9462 1.61122 4.20588 2.91879 3.56697 4.7501L5.48913 4.7501L2.74456 8.56134L0 4.7501L1.88891 4.7501ZM10.5111 7.85573L13.2556 4.04449L16 7.85591L14.1056 7.85591C13.4131 10.5838 10.9395 12.6115 7.99991 12.6115C6.23669 12.6115 4.6401 11.8837 3.49426 10.7114L4.44983 9.38917C5.30957 10.3774 6.58183 11.0003 7.99991 11.0003C10.0561 11.0003 11.7916 9.68971 12.4277 7.85573L10.5111 7.85573Z"
      id="Fill-1"
      fill="#008FBE"
      fillRule="evenodd"
      stroke="none"
    />
  </svg>
)
